export const COMMON_TEXT = {
    UPDATE: 'Update',
    PROPERTIES: 'PROPERTIES',
    EMPTY_STRING: 'Field cannot be empty'
}

export const STEP = {
    INTEGER: '1',
    FLOAT: '0.1'
}